export default __webpack_public_path__ + "static/media/bonus.2fee2cca.svg";